import { render } from "./Case.vue?vue&type=template&id=58b5c2e8&scoped=true"
import script from "./Case.vue?vue&type=script&lang=ts"
export * from "./Case.vue?vue&type=script&lang=ts"

import "./Case.vue?vue&type=style&index=0&id=58b5c2e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58b5c2e8"

export default script